import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    cashTitle: 'By cash deposit',
    checkTitle: 'By cashing a check',
    headline: 'Start using your account by crediting it',
    invoicingClientsTitle: 'By invoicing your clients',
    sepaTitle: 'By SEPA transfer',
  },
  fr: {
    cashTitle: 'Par dépôt d’espèces',
    checkTitle: 'Par encaissement de chèque',
    headline: 'Commencez à utiliser votre compte en le créditant',
    invoicingClientsTitle: 'Par facturation de vos clients',
    sepaTitle: 'Par virement SEPA',
  },
} as const);

export default locales;
